module.exports = __webpack_public_path__ + "img/poland.f3d04a2e.svg";